import { IFaqItem } from '@/components/Faq/QuestionList';

interface Props {
    question: IFaqItem;
    index: number;
    isOpen: boolean;
    onToggle: () => void;
}

const ChevronIcon = (
    <svg
        className="faq-chev-svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <polyline points="6 9 12 15 18 9" />
    </svg>
);

function splitParagraphs(text: string): string[] {
    return (text || '')
        .split(/\n+/)
        .map((s) => s.trim())
        .filter(Boolean);
}

const Question = ({ question, index, isOpen, onToggle }: Props) => {
    const paragraphs = splitParagraphs(question.description);

    return (
        <div className={`faq-item ${isOpen ? 'open' : ''}`}>
            <div className="faq-head" onClick={onToggle}>
                <span className="faq-num">{index.toString().padStart(2, '0')}</span>
                <span className="faq-title">{question.title}</span>
                <span className="faq-chev">{ChevronIcon}</span>
            </div>
            <div className="faq-body">
                <div>
                    {paragraphs.length > 0 ? (
                        paragraphs.map((p, i) => <p key={i}>{p}</p>)
                    ) : (
                        <p>{question.description}</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Question;
